'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getFetchActionTypes = exports.getFetchActionTypes = function getFetchActionTypes(type) {
  return ['MINDSELF_' + type, 'MINDSELF_' + type + '_SUCCESS', 'MINDSELF_' + type + '_FAIL'];
};

var apiPrefix = exports.apiPrefix = '/v1';


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/utils/actions.js
// module id = 44
// module chunks = 1